// 9fbef606107a605d69c0edbcd8029e5d
import ADDRESS_BOOK_CONSTANTS from '../AddressBook.constants';

export const getAddressList = (payload) => ({
  type: ADDRESS_BOOK_CONSTANTS.GET_ADDRESS_LIST,
  payload,
});

export const getAddressListPlcc = (payload) => ({
  type: ADDRESS_BOOK_CONSTANTS.GET_ADDRESS_LIST_PLCC,
  payload,
});

export const setAddressList = (addressList, fromProfile) => ({
  type: ADDRESS_BOOK_CONSTANTS.SET_ADDRESS_LIST,
  addressList,
  fromProfile,
});

export const loadAddAddressComponent = () => ({
  type: ADDRESS_BOOK_CONSTANTS.LOAD_ADD_ADDRESS_COMPONENT,
});

export const loadAddressBookComponent = () => ({
  type: ADDRESS_BOOK_CONSTANTS.LOAD_ADDRESSBOOK_COMPONENT,
});

export const setEditAddress = (payload) => {
  return {
    type: ADDRESS_BOOK_CONSTANTS.SET_EDIT_ADDRESS_ITEM,
    payload,
  };
};
export const updateAddressListOnDelete = (payload) => ({
  type: ADDRESS_BOOK_CONSTANTS.UPDATE_ADDRESS_LIST_ON_DELETE,
  payload,
});

export const updateAddressListOnDeleteErr = (payload) => ({
  type: ADDRESS_BOOK_CONSTANTS.UPDATE_ADDRESS_LIST_ON_DELETE_ERR,
  payload,
});
export const clearErrorState = () => ({
  type: ADDRESS_BOOK_CONSTANTS.CLEAR_ERROR_STATE,
});

export const deleteAddress = (payload) => ({
  type: ADDRESS_BOOK_CONSTANTS.DELETE_ADDRESS,
  payload,
});

export const setDeleteModalMountedState = (payload) => ({
  type: ADDRESS_BOOK_CONSTANTS.DELETE_MODAL_MOUNTED_STATE,
  payload,
});

export const clearGetAddressListTTL = () => ({
  type: ADDRESS_BOOK_CONSTANTS.CLEAR_GET_ADDRESS_LIST_TTL,
});

export const showLoader = () => ({
  type: ADDRESS_BOOK_CONSTANTS.SHOW_LOADER,
});

export const hideLoader = () => ({
  type: ADDRESS_BOOK_CONSTANTS.HIDE_LOADER,
});

export const setAddressBookNotification = (payload) => ({
  type: ADDRESS_BOOK_CONSTANTS.SET_ADDRESS_BOOK_NOTIFICATION,
  payload,
});
